__turbopack_context__.v({
  "check": "uBWFVa_check",
  "chevron": "uBWFVa_chevron",
  "chip": "uBWFVa_chip",
  "clear": "uBWFVa_clear",
  "control": "uBWFVa_control",
  "count": "uBWFVa_count",
  "description": "uBWFVa_description",
  "field": "uBWFVa_field",
  "hasClear": "uBWFVa_hasClear",
  "label": "uBWFVa_label",
  "menu": "uBWFVa_menu",
  "more": "uBWFVa_more",
  "option": "uBWFVa_option",
  "placeholder": "uBWFVa_placeholder",
  "slot": "uBWFVa_slot",
  "srOnly": "uBWFVa_srOnly",
  "trigger": "uBWFVa_trigger",
  "value": "uBWFVa_value",
});
